import apiFn from '../api-service';
import { GetThemeResponse, Theme } from './types';

const api = (eventId: string | number) =>
  apiFn(`/api/uapi/events/${eventId}/event-space`, {
    Accept: 'application/vnd.eventmobi+json; version=p.7',
  });

export const get = async (eventId: string | number): APIResponse<GetThemeResponse> => {
  const params = new URLSearchParams();
  params.set('include', 'theme');

  const response = await api(eventId).get(null, { params });

  return response.data;
};

export const upsert = async (eventId: string | number, payload: Partial<Theme> = {}) =>
  api(eventId).patch(null, { theme: payload });
